module.exports = __webpack_public_path__ + "img/xingxushi.2a6c3a46.svg";